var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 9.5,
    x2: 20,
    y2: 9.5,
    stroke: "currentColor"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 10.5,
    y1: 2.18557e-8,
    x2: 10.5,
    y2: 20,
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBig);
export default __webpack_public_path__ + "static/media/plus_big.44be9ab5500f7a3e9a837e5b5bd7a2fb.svg";
export { ForwardRef as ReactComponent };